import { FeatureFlagType } from '~/enums/FeatureFlagType';
import { testHasFlag } from '~/permissions/utils/testHasFlag';

export const getInitialConfigs = ({ currentUser }: { currentUser: any }) => {
  const hasDisableDocTaggingFlag = testHasFlag(
    FeatureFlagType.DisableDocTagging,
  )(currentUser);

  return {
    clauseTagsAccessMode: hasDisableDocTaggingFlag
      ? ['restrict_all_users']
      : [],
  };
};
